<template>
  <a-breadcrumb>
    <a-breadcrumb-item
      class="breadcrumbItem"
      v-for="(item, index) in breadcrumbStack"
      :key="index"
      @click="handleNavigate(index)"
    >
      <span v-if="item.htmlTitle" v-html="item.htmlTitle"></span>
      <span v-else>{{ item.title }}</span>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script setup>
import { ref, reactive, defineEmits, defineExpose, watch } from 'vue'
const emit = defineEmits(['updateView'])
/**
 * 面包屑导航栈，每一项是一个对象
 * @property {any} htmlTitle - 支持 HTML 标签的标题（通过 v-html 渲染，可包含样式、颜色等）
 * @property {any} title - 纯文本标题（不包含 HTML 标签，直接文本渲染）
 * @property {any} component - 对应要渲染的组件（建议使用 markRaw 包装）
 * @property {Object} props - 组件所需的参数
 */
const breadcrumbStack = reactive([])
// 当前所在组件
const currentComponent = ref(null)
// 当前所在组件所需参数
const currentProps = ref(null)
// 强制刷新子组件
const componentKey = ref(0)
// 更新当前视图
const updateCurrentView = (index = breadcrumbStack.length - 1) => {
  if (!breadcrumbStack[index]) return
  const { component, props } = breadcrumbStack[index]
  currentComponent.value = component
  currentProps.value = { ...props }
  // 强制刷新
  componentKey.value++
}
// 面包屑导航新增层级
const pushStack = newStack => {
  breadcrumbStack.push(newStack)
  updateCurrentView()
}
// 返回指定层级
const handleNavigate = index => {
  breadcrumbStack.splice(index + 1)
  updateCurrentView()
}
// 清空面包屑栈
const resetStack = () => {
  breadcrumbStack.splice(0)
  currentComponent.value = null
  currentProps.value = null
  componentKey.value = 0
}
watch([currentComponent, currentProps, componentKey], () => {
  emit('updateView', {
    component: currentComponent.value,
    props: currentProps.value,
    key: componentKey.value
  })
})
defineExpose({
  pushStack,
  resetStack
})
</script>

<style scoped lang="scss">
.breadcrumbItem {
  font-size: 16px;
  cursor: pointer;
  ::v-deep(.breadcrumb-username) {
    color: #999;
    font-size: 14px;
  }
}
</style>
